import React from 'react';
import TitleContainer from './components/TitleContainer';
import ActivityLocation from './components/ActivityLocation';
import ActivityContact from './components/ActivityContact';
import ActivityChemical from './components/ActivityChemical';
import ActivityText from './components/ActivityText';
import { useTranslation } from 'react-i18next';
import styles from './components/styles/Activity.module.scss';
import { Card } from 'semantic-ui-react';
import { ActivityState } from './types/ActivityStates';
import { useState, useEffect } from 'react';
import ChemicalDetailsCard from './components/ChemicalDetailsCard';
import { CREATE_MODE, VIEW_MODE } from '@src/constants';
import { ActivityChemicalsDTO } from '@behavior/activity/dto/ActivityChemicalsDTO';
import { ActivityInitialDataResponse } from './types/ActivityInitialDataResponse';

type Props = {
  mode: string;
  initialData?: ActivityInitialDataResponse;
  disabled?: boolean;
  activity: ActivityState;
};

const ActivityDetailsContainer = ({ mode, initialData, disabled, activity }: Props) => {
  const { t } = useTranslation();
  const [chemicalProduct, setChemicalProduct] = useState<ActivityChemicalsDTO[]>();

  useEffect(() => {
    if (activity && mode != CREATE_MODE) {
      const { chemicalProductsList } = activity;
      setChemicalProduct(chemicalProductsList);
    }
  }, [activity]);

  return (
    <div className={styles.component}>
      <Card className={styles.card}>
        <TitleContainer header={'activity.details.page.activity.details.container.title'} />
        <div className={styles.locationContactRow}>
          <div className={styles.locationContainer}>
            <ActivityLocation
              selectedLocations={activity.selectedLocations}
              setSelectedLocations={activity?.setSelectedLocations}
              outOfBuilding={activity?.outOfBuilding}
              setOutOfBuilding={activity?.setOutOfBuilding}
              disabled={disabled}
              mode={mode}
            />
          </div>

          <div className={styles.contactContainer}>
            <ActivityContact
              initialData={initialData}
              selectedContacts={activity?.selectedContacts}
              setSelectedContacts={activity.setSelectedContacts}
              department={activity?.department}
              setDepartment={activity.setDepartment}
              disabled={disabled}
            />
          </div>
        </div>
        {disabled ? (
          chemicalProduct?.map((chemical: any) => (
            <Card key={`chemical_${chemical.id}_card`} className={styles.cardText}>
              <ChemicalDetailsCard
                key={chemical.id}
                chemicalProductId={chemical.chemicalProduct.id}
                chemicalProductsList={chemical.chemicalProduct}
                disabled
              />
            </Card>
          ))
        ) : (
          <div>
            <ActivityChemical {...activity} />
          </div>
        )}

        {mode !== VIEW_MODE && (
          <div>
            <ActivityText
              isTitle
              header={t('activity.details.page.components.activity.text.title')}
              setTitle={activity.setTitle}
              name="title"
              title={activity?.title}
              disabled={disabled}
            />
          </div>
        )}

        <div>
          <ActivityText
            header={t('activity.details.page.components.activity.text.description')}
            setText={activity.setText}
            name="description"
            text={activity?.text}
            disabled={disabled}
          />
        </div>
      </Card>
    </div>
  );
};

export default ActivityDetailsContainer;
